<template>
    <div v-if="jobDetails && checklistResponses">
        <div class="row">
            <div class="col-xs-12 col-sm-12 col-md-12 col-lg-8 offset-lg-2">
                <form>                    
                    <div class="card">
                        <div class="card-body">
                            <h3 class="card-title" style="color: rgb(76, 106, 176);">
                                Charters-Reid Surveyors Vendor Questionnaire
                            </h3>
                            <h5><span class="fa fa-home text-success mr-1"></span> Address: {{ jobDetails.address }}</h5>
                            <h5><span class="fa fa-calendar-o text-success mr-1"></span> Date of Survey: {{ moment(jobDetails.date).format('DD/MM/YYYY') }}</h5>
                            <h5><span class="fa fa-info-circle text-success mr-1"></span> Our Reference: {{ jobDetails.job_ref }}</h5>
                            <p class="mt-3">
                                Dear Vendor. Thank you for taking the time to fill out this brief Questionnaire. 
                                This helps us not only make your buying and selling process more efficient, 
                                but also allows us to comply with current COVID 19 regulations.
                            </p>
                            <p>
                                If you have any questions at all about the survey at your property, or the buying and selling 
                                process in general, please don't hesitate to give us a call on 01904 468 881. We would be happy to help.
                            </p>
                            <hr>

                            <div class="row mb-4" v-for="item in checklistResponses" :key="item.base_item_id">
                                <div class="col">
                                    <div v-if="!item.display_only">
                                        <h5>{{ item.display_text }}</h5>

                                        <!-- Free text input -->
                                        <div v-if="getInputType(item)== 'text'">
                                            <input type="text" class="form-control" :class="item.invalid ? 'invalid' : ''" v-model="item.value">
                                        </div>

                                        <!-- Options input -->
                                        <div v-if="getInputType(item) == 'select'">
                                            <select class="form-control" :class="item.invalid ? 'invalid' : ''" v-model="item.value">
                                                <option value="" disabled selected>Please select</option>
                                                <option v-for="opt in item.select_options" :key="opt">{{ opt }}</option>
                                            </select>
                                        </div>

                                        <!-- Bool input -->
                                        <div v-if="getInputType(item) == 'bool'">
                                            <select class="form-control" :class="item.invalid ? 'invalid' : ''" v-model="item.value">
                                                <option value="" disabled selected>Please select</option>
                                                <option>Yes</option>
                                                <option>No</option>
                                            </select>
                                        </div>
                                    </div>

                                    <div class="" v-if="item.display_only">
                                        <p class="card-text">{{ item.display_text }}</p>
                                    </div>
                                </div>
                            </div>                        
                        </div>

                        <div class="card-footer">
                            <button class="btn btn-success btn-block btn-lg" type="button" :disabled="isProcessing" @click="submitQuestionnaire">
                                <span class="fa fa-check mr-2" v-if="!isProcessing"></span> 
                                <span class="fa fa-spinner fa-spin mr-2" v-if="isProcessing"></span> 
                                Submit Questionnaire
                            </button>

                            <p class="text-danger text-center mt-2" style="font-size: 1.2em;" v-if="hasMissingResponses">
                                <strong>Please fill out all required fields</strong>
                            </p>

                            <div class="alert alert-danger" v-if="submitError">
                                We're sorry, something went wrong while saving your responses.
                            </div>
                        </div>
                    </div>
                </form>
            </div>
        </div>
    </div>
</template>

<script>
    import _ from 'lodash'
    import axios from 'axios'

    export default {
        props: {
            jobDetails: Object,
            checklistTemplateProp: Array
        },
        data() {
            return {
                hasMissingResponses: false,
                checklistResponses: null,
                isProcessing: false,
                submitError: null,
            }
        },
        mounted() {
            if (!this.jobDetails || !this.checklistTemplateProp) {
                return window.location.href = 'https://www.surveys4you.co.uk/'
            }

            this.checklistResponses = this.checklistTemplateProp
        },
        methods: {
            async submitQuestionnaire() {
                this.hasMissingResponses = false
                this.error = null

                // Validate responses
                this.checklistResponses.forEach((r, idx) => {
                    if ((r.input_type == 'bool' || r.input_type == 'select') && (!r.value || r.value.length == 0)) {
                        this.hasMissingResponses = true
                    }
                })
                
                if (this.hasMissingResponses) {                    
                    alert('Please fill out all required fields')
                }
                else {
                    this.isProcessing = true
                    try {
                        let responseValues = this.checklistResponses.filter(r => !r.display_only).map(r => {
                            return {
                                base_item_id: r.item_id,
                                display_text: r.display_text,
                                value: r.value
                            }
                        })

                        let responsesUrl = `/.netlify/functions/save-vendor-checklist-response`
                        let submitResponse = await axios.post(responsesUrl, {
                            job_reference: this.jobDetails.job_ref,
                            values: responseValues
                        })

                        this.$router.push({ name: 'vendor-checklist-success' })
                    } catch (error) {
                        this.submitError = error
                    }

                    this.isProcessing = false
                }
            },
            getInputType(itemTemplate) {
                let input = itemTemplate.input_type
                let hasSelectOptions = itemTemplate.select_options && itemTemplate.select_options.length > 0

                switch (input) {
                    case 'text':
                    case 'bool':
                        return input
                        break
                
                    case 'select':
                        return hasSelectOptions ? 'select' : 'text'
                        break

                    default:
                        return 'text'
                        break
                }
            }
        }
    }
</script>

<style lang="scss">
    input.invalid, select.invalid {
        border: 1px solid red;
    }
</style>